import TranslationProvider from '@/provider/translations.js'
import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'

export const canDelegateCC = async (compiledPoll, modalBulkActionsPayload) => {
    if (!modalBulkActionsPayload['cc']){
    return null;
  }
  return canDelegate(compiledPoll, modalBulkActionsPayload, 'delegateCC')
}

export const canDelegateDT = async (compiledPoll, modalBulkActionsPayload) => {
    if (!modalBulkActionsPayload['dt']){
    return null;
  }
  return canDelegate(compiledPoll, modalBulkActionsPayload, 'delegateDT')
}

export const getCategories = async () => {
  try {
    let url = `/custom/cmb/gec/categories`
    return await client.get(url)

  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

const canDelegate = async (compiledPoll, modalBulkActionsPayload, type) => {
  const url = '/custom/cmb/bulk/can-delegate';
  try{
    const res = await client.post(url, {
      type,
      compiledPoll,
      modalBulkActionsPayload
    }, 'application/json')

    if (res.status === 'ok') {
      return null;
    }else{
      return TranslationProvider.getTrans(res.error)
    }
  }catch (e) {
    return TranslationProvider.getTrans('app.massive_error_delegate_cc')
  }
}
